/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group A,Group B
5,8
6,9
7,7`)
};

const es_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo A,Grupo B
5,8
6,9
7,7`)
};

const de_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group A,Group B
5,8
6,9
7,7`)
};

const nl_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groep A,Groep B
5,8
6,9
7,7`)
};

const fr_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe A,Groupe B
5,8
6,9
7,7`)
};

const it_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo A,Gruppo B
5,8
6,9
7,7`)
};

const pt_br2_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo A,Grupo B
5,8
6,9
7,7`)
};

const pt_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo A,Grupo B
5,8
6,9
7,7`)
};

const ja_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group A,Group B
5,8
6,9
7,7`)
};

const zh_box_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group A,Group B
5,8
6,9
7,7`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_placeholder", locale)
	if (locale === "en") return en_box_placeholder(inputs)
	if (locale === "es") return es_box_placeholder(inputs)
	if (locale === "de") return de_box_placeholder(inputs)
	if (locale === "nl") return nl_box_placeholder(inputs)
	if (locale === "fr") return fr_box_placeholder(inputs)
	if (locale === "it") return it_box_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_box_placeholder(inputs)
	if (locale === "pt") return pt_box_placeholder(inputs)
	if (locale === "ja") return ja_box_placeholder(inputs)
	return zh_box_placeholder(inputs)
};